import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";
import type { Moment } from "moment";
import type React from "react";

const StyledTextField = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "center",
  },
});

type Props = {
  value: Moment;
  onChange: (date: Moment | null) => void;
  minDate?: Moment;
  maxDate?: Moment;
  onOpen?: () => void;
  onClose?: () => void;
  size?: "small" | "medium";
};

export const StartFilter: React.FC<Props> = ({
  value,
  onChange,
  minDate,
  maxDate,
  onOpen,
  onClose,
  size,
}) => {
  return (
    <DatePicker
      label="Start"
      format="MM/DD/YYYY"
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      onOpen={onOpen}
      onClose={onClose}
      onChange={(newValue) => {
        onChange(newValue);
      }}
      slots={{ textField: StyledTextField }}
      slotProps={{ textField: { fullWidth: true, size } }}
    />
  );
};

export const EndFilter: React.FC<Props> = ({
  value,
  onChange,
  minDate,
  maxDate,
  onOpen,
  onClose,
  size,
}) => {
  return (
    <DatePicker
      label="End"
      format="MM/DD/YYYY"
      value={value}
      minDate={minDate}
      maxDate={maxDate}
      onOpen={onOpen}
      onClose={onClose}
      onChange={(newValue) => {
        onChange(newValue);
      }}
      slots={{ textField: StyledTextField }}
      slotProps={{ textField: { fullWidth: true, size } }}
    />
  );
};
